import { render } from "./BanobagiBottomNavigation.vue?vue&type=template&id=f7601cae&scoped=true"
import script from "./BanobagiBottomNavigation.vue?vue&type=script&lang=js"
export * from "./BanobagiBottomNavigation.vue?vue&type=script&lang=js"

import "./BanobagiBottomNavigation.vue?vue&type=style&index=0&id=f7601cae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7601cae"]])

export default __exports__